<template>
    <div>
    <el-card style="height: 100vh;">
        <div class="nav-header">
            <div class="item active">
                核销绑定
            </div>
            <!-- <div class="item">
                团购配送
            </div> -->
        </div>
        <div class="line-block">
            <h4>门店信息</h4>
        </div>
        <div class="avatar-text">
            <img src="../../assets/images/defaultPlist.png" alt="">
            <div class="text">
                <div class="store">
                    <span style="color: rgba(0,0,0,0.85);">门店：</span>{{ merchantName }}({{ baseInfo.merchantCode }})
                </div>
                <div class="store store-address ">
                    <span style="color: rgba(0,0,0,0.85);">门店地址： </span>{{ baseInfo.address }}
                </div>  
                <div class="extra">
                    <span @click="bindStore">绑定美团门店</span>
                </div>
            </div>
        </div>
    </el-card>
    </div>
</template>

<script >
export default{
    data(){
        return{
            merchantName:'',
            merchantCode:'',
            baseInfo:[]
        }
    },
    methods:{
        getBaseInfo(){
            this.$http.post('/merchantBaseInfo/queryOne',{merchantCode:this.merchantCode}).then(res=>{
                console.log(res,'地址')
                this.baseInfo=res.data.data
            })
        },
        bindStore(){
            // 团购businessId固定为1, 外卖为2
            this.$http.post('/meituanAppAuthToken/getAppAuthTokenLink',{businessId:1,merchantCode:12,merchantName:this.merchantName}).then(res=>{
                if(res.data.code==200){
                    var link=document.createElement('a')
                    link.href=res.data.data
                    // link.click()
                    window.open(res.data.data)
                }else{
                    this.$message.error(res.data.message)
                }
            })
        }
    },
    created(){
        this.merchantName=localStorage.getItem('merchantName')
        this.merchantCode=localStorage.getItem('merchantCode')
        this.getBaseInfo()
    },
    mounted(){

    }
}
</script>

<style lang="less" scoped>
.nav-header{
    display: flex;
    margin-bottom: 17px;
    .item{
        width: 56px;
        height: 21px;
        padding: 12px 16px;
        margin-right: 32px;
        font-size: 14px;
        color: #333;
        cursor: pointer;
    }
    .item.active{
       border-bottom: 2px solid #ffbd00;
       font-weight: 500;
       color: #000;
}
}
.line-block{
   
    h4{
        font-size: 14px;
    padding-left: 8px;
    margin-top: unset;
    margin-bottom: 14px;
    border-left: 4px solid rgb(255, 189, 0);
    text-align: left;
    color: rgb(34,34,34);
    font-weight: 500;


    }
}
.avatar-text{
    height: 100px;
    display: flex;
    img{
        height: 100px;
        width: 100px;
        display: block;
        margin-right: 14px;
    }
    .text{
        display: flex;
    flex-direction: column;
    text-align: left;
    width: 90%;
    font-size: 14px;
    .store{
        height: 22px;
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.65);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .store.store-address{
        margin-bottom: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    }
    .extra{
        span{
            color: rgba(255, 96, 0,1);
            cursor: pointer;
        }
        span:hover{
            color: rgba(255,96,0,0.85);
        }
    }
    }
}
</style>